import { render, staticRenderFns } from "./icons.component.vue?vue&type=template&id=0b486b70"
import script from "./icons.component.vue?vue&type=script&lang=js"
export * from "./icons.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports